import React from "react";
import { LibraryPrivacyFilter } from "../../constants";
import { CoachLibraryHeader } from "../library/CoachLibraryHeader";
import {
  CoachLibraryHeaderFiltersBaseProps,
  getLibraryPrivacyOptions,
} from "../exercise-library/CoachExerciseLibraryHeaderFilters";
import { useCurrentUser } from "../../hooks/useCurrentUser";

export interface CoachProgramLibraryHeaderFiltersProps
  extends CoachLibraryHeaderFiltersBaseProps {
  showFilterByType?: boolean;
}

export function CoachProgramLibraryHeaderFilters(
  props: CoachProgramLibraryHeaderFiltersProps,
) {
  const {
    className,
    query,
    onChangeQuery,
    privacy,
    onChangePrivacy,
    defaultQuery,
    disabledResetButton,
    onResetFilters,
    showResetButton,
    showFilterByType,
  } = props;

  const { isTeamAccount } = useCurrentUser();

  const handlePrivacyChange = React.useCallback(
    (value: LibraryPrivacyFilter) => {
      onChangePrivacy?.(value);
    },
    [onChangePrivacy],
  );

  return (
    <CoachLibraryHeader<LibraryPrivacyFilter>
      className={className}
      query={query}
      defaultQuery={defaultQuery}
      searchPlaceholder="Search by name"
      onChangeQuery={onChangeQuery}
      toggleOptions={
        showFilterByType
          ? getLibraryPrivacyOptions("program", isTeamAccount)
          : undefined
      }
      toggleValue={privacy}
      onChangeToggle={handlePrivacyChange}
      showResetButton={showResetButton}
      disabledResetButton={disabledResetButton}
      onResetFilters={onResetFilters}
    />
  );
}
